// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./assets/fonts/Lato-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./assets/fonts/Lato-Bold.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Global Lato font from assets/fonts - same as PreDashboard */
@font-face {
  font-family: "Lato";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("truetype");
  font-weight: 400;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: "Lato";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("truetype");
  font-weight: 700;
  font-style: normal;
  font-display: swap;
}

/* Apply Lato everywhere like PreDashboard */
html,
body,
#root {
  font-family: "Lato", sans-serif !important;
}
`, "",{"version":3,"sources":["webpack://./src/global-fonts.css"],"names":[],"mappings":"AAAA,8DAA8D;AAC9D;EACE,mBAAmB;EACnB,+DAA8D;EAC9D,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,+DAA2D;EAC3D,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA,4CAA4C;AAC5C;;;EAGE,0CAA0C;AAC5C","sourcesContent":["/* Global Lato font from assets/fonts - same as PreDashboard */\r\n@font-face {\r\n  font-family: \"Lato\";\r\n  src: url(\"./assets/fonts/Lato-Regular.ttf\") format(\"truetype\");\r\n  font-weight: 400;\r\n  font-style: normal;\r\n  font-display: swap;\r\n}\r\n\r\n@font-face {\r\n  font-family: \"Lato\";\r\n  src: url(\"./assets/fonts/Lato-Bold.ttf\") format(\"truetype\");\r\n  font-weight: 700;\r\n  font-style: normal;\r\n  font-display: swap;\r\n}\r\n\r\n/* Apply Lato everywhere like PreDashboard */\r\nhtml,\r\nbody,\r\n#root {\r\n  font-family: \"Lato\", sans-serif !important;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
